export enum OrgTreeNodeType {
  None = null,
  Organization = 1,
  Site = 2,
  Location = 3,
  Asset = 4,
  Component = 5,
  Part = 6,
}
